export class Email {
  emailAddress: string;
  email: string;
  emailType: string;
}
